import React from 'react';

import { Checkbox } from 'e100-react-components';

import { IPropTypes as CheckboxProps } from 'e100-react-components/lib/components/Checkbox';

import { useIntl } from 'react-intl';
import { useIsMapsClient } from 'store/features/auth';

export const FavouriteStationsSettingField = (props: FavouriteStationsSettingFieldProps) => {
  const { formatMessage } = useIntl();
  const isMapsClient = useIsMapsClient();

  if (!isMapsClient) {
    return null;
  }

  return (
    <Checkbox
      labelPlacement={'start'}
      label={formatMessage({ id: 'abilityToBeSelectedForYourManager' })}
      fullWidth
      checkboxPadding={{
        top: 0,
        right: 0,
        bottom: 0
      }}
      {...props}
    />
  )
};

export interface FavouriteStationsSettingFieldProps extends CheckboxProps {}
